/* eslint-disable no-param-reassign */
import {get} from 'lodash';

const defaultSortOptions = {ignoreCase: true, order: 'asc'};

export const sortAlphabetically = (a, b, options = defaultSortOptions) => {
  if (!b && !a) return 0;
  if (a && !b) return 1;
  if (b && !a) return -1;

  if (options.ignoreCase) a = a.toLowerCase();
  if (options.ignoreCase) b = b.toLowerCase();

  const sortOrder = options.order === 'asc' ? 1 : -1;

  if (a < b) return -1 * sortOrder;
  if (a > b) return sortOrder;
  return 0;
};

// eslint-disable-next-line arrow-body-style
export const sortAlphabeticallyByPath = (a, b, path, options = defaultSortOptions) => {
  return sortAlphabetically(get(a, path), get(b, path), options);
};

export const sortNumerically = (a, b) => {
  let parsedA = parseInt(a, 10);
  let parsedB = parseInt(b, 10);

  if (!Number.isFinite(parsedA) && !Number.isFinite(parsedB)) {
    parsedA = 0;
    parsedB = 0;
  }

  if (!Number.isFinite(parsedA) && Number.isFinite(parsedB)) {
    parsedA = parsedB + 1;
  }

  if (Number.isFinite(parsedA) && !Number.isFinite(parsedB)) {
    parsedB = parsedA + 1;
  }

  return parsedA - parsedB;
};

export const sortNumericallyByPath = (a, b, path) => sortNumerically(get(a, path), get(b, path));

export const sortChronologically = (a, b) => new Date(a) - new Date(b);
// eslint-disable-next-line max-len
export const sortChronologicallyIgnoreMilliseconds = (a, b) => new Date(a).setMilliseconds(0) - new Date(b).setMilliseconds(0);

export const sortBoolean = (a, b) => b - a;
